import { NavLink } from 'react-router-dom';
import {
  HomeIcon,
  CubeIcon,
  TruckIcon,
  ArrowsRightLeftIcon,
  UserPlusIcon,
  MapPinIcon,
  TagIcon,
  BuildingLibraryIcon,
  ClipboardDocumentListIcon,
  ServerStackIcon,
  DocumentArrowDownIcon,
  XMarkIcon,
} from '@heroicons/react/24/outline';

const AIG_LOGO_URL = 'https://americanindependencegold.com/wp-content/uploads/2024/12/AIg-moving-logo.gif';

const navGroups = [
  {
    label: 'Overview',
    items: [
      { to: '/', icon: HomeIcon, label: 'Dashboard' },
      { to: '/inventory', icon: CubeIcon, label: 'Inventory' },
    ],
  },
  {
    label: 'Workflows',
    items: [
      { to: '/outshipments', icon: TruckIcon, label: 'Outshipments' },
      { to: '/transfers', icon: ArrowsRightLeftIcon, label: 'Transfers' },
      { to: '/new-accounts', icon: UserPlusIcon, label: 'New Accounts' },
    ],
  },
  {
    label: 'Reference',
    items: [
      { to: '/accounts', icon: BuildingLibraryIcon, label: 'Accounts' },
      { to: '/products', icon: TagIcon, label: 'Products' },
      { to: '/addresses', icon: MapPinIcon, label: 'Address Book' },
    ],
  },
  {
    label: 'System',
    items: [
      { to: '/sftp', icon: ServerStackIcon, label: 'SFTP Monitor' },
      { to: '/exports', icon: DocumentArrowDownIcon, label: 'Exports' },
      { to: '/audit', icon: ClipboardDocumentListIcon, label: 'Audit Log' },
    ],
  },
];

interface SidebarProps {
  onClose: () => void;
}

export function Sidebar({ onClose }: SidebarProps) {
  return (
    <nav className="flex h-full flex-col bg-silver-900 text-white">
      {/* Logo / Brand */}
      <div className="flex items-center justify-between border-b border-silver-700 px-4 py-4">
        <div className="flex items-center gap-3">
          <img src={AIG_LOGO_URL} alt="American Independence Gold" className="h-10 w-10 rounded-lg object-contain" />
          <div>
            <p className="text-sm font-bold leading-tight text-gold-400">American</p>
            <p className="text-sm font-bold leading-tight text-gold-400">Independence Gold</p>
          </div>
        </div>
        <button onClick={onClose} className="rounded-lg p-1 text-silver-400 hover:text-white lg:hidden">
          <XMarkIcon className="h-5 w-5" />
        </button>
      </div>

      {/* Navigation */}
      <div className="flex-1 overflow-y-auto px-3 py-4">
        {navGroups.map((group) => (
          <div key={group.label} className="mb-6">
            <p className="mb-2 px-3 text-xs font-semibold uppercase tracking-wider text-silver-500">
              {group.label}
            </p>
            <ul className="space-y-1">
              {group.items.map((item) => (
                <li key={item.to}>
                  <NavLink
                    to={item.to}
                    end={item.to === '/'}
                    onClick={onClose}
                    className={({ isActive }) =>
                      `flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors
                      ${isActive
                        ? 'bg-gold-600/20 text-gold-400'
                        : 'text-silver-300 hover:bg-silver-800 hover:text-white'
                      }`
                    }
                  >
                    <item.icon className="h-5 w-5 shrink-0" />
                    {item.label}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {/* Footer */}
      <div className="border-t border-silver-700 px-4 py-3">
        <p className="text-xs text-silver-500">AIGftpwatch v0.1</p>
      </div>
    </nav>
  );
}
